export const RISK_FILTERS = ['1', '2', '3', '4', '5']
export const ASSET_CLASS_FILTERS = [
  'equity',
  'fixed_income',
  'money_market',
  'multi_asset',
  'sector_specialty',
]
export const REGION_FILTERS = ['us', 'international']
export const MARKET_CAPITALIZATION_FILTERS = [
  'large-cap',
  'mid-cap',
  'small-cap',
]
export const STYLE_FILTERS = ['value', 'blend', 'growth']
export const CREDIT_QUALITY_FILTERS = ['high', 'medium', 'low']
export const MATURITY_FILTERS = ['short', 'medium', 'long']
export const INVESTMENT_MINIMUM_FILTERS = [
  '1-1000',
  '1000-3000',
  '3000-10000',
  '10000-25000',
  '25000-50000',
  '50000>',
  'closed',
]
export const SHARE_CLASS_FILTERS = [
  'investor_shares',
  'admiral™_shares',
  'institutional_shares',
]
export const MANAGEMENT_STYLE_FILTERS = ['active', 'index']
export const PRODUCT_TYPE = ['mutual-funds', 'etfs']

export const STRATEGY_FILTERS = ['all_in_one', 'total_market_etfs', 'esg', 'cash']
export const STRATEGY_FILTERS_529 = ['individual_balanced', 'target_enrollment', 'individual']
export const TAX_EFFICIENCY_FILTERS = ['taxable', 'tax-managed', 'tax-exempt']

export const FILTER_MAP = {
  'us':'US',
  'international':'International',
  'large-cap':'Large-Cap',
  'mid-cap':'Mid-Cap',
  'small-cap':'Small-Cap',
  'value':'Value',
  'blend':'Blend',
  'growth':'Growth',
  'high':'High',
  'medium':'Medium',
  'low':'Low',
  'short':'Short',
  'long':'Long',
  'all_in_one':'All-in-One',
  'total_market_etfs':'Total Market ETFs',
  'esg':'ESG',
  'cash': 'Cash',
  'investor_shares':'Investor Shares',
  'admiral™_shares':'Admiral™ Shares',
  'institutional_shares':'Institutional Shares',
  'equity':'Stocks',
  'fixed_income':'Fixed Income',
  'money_market':'Money Market',
  'multi_asset':'Balanced',
  'sector_specialty':'Sector & Specialty',
  'taxable':'Taxable',
  'tax-managed':'Tax-Managed',
  'tax-exempt':'Tax-Exempt',
  'active':'Active',
  'index':'Index',
  'mutual-funds':'Mutual funds',
  'etfs':'ETFs',
  'individual_balanced':'Individual balanced portfolios',
  'target_enrollment': 'Target enrollment',
  'individual': 'Individual portfolios'
}
